import type { FC } from 'react'
import React from 'react'
import Skeleton from '@material-ui/lab/Skeleton'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import type { ITheme } from '@homeviews/styles'
import { Typography } from '@homeviews/shared-ui'

const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    root: {
      marginBottom: theme.spacing(2),
      // backgroundColor: '#f9f9f9'
    },
    skeletonImage: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
    header: {
      position: 'relative',
      height: 0,
      borderRadius: '3px',
      overflow: 'hidden',
      paddingBottom: `${(204 / 317) * 100}%`,
    },
  }),
)

const ReviewCardSkeleton: FC = () => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <Skeleton className={classes.skeletonImage} variant="rect" />
      </div>
      <Typography
        variant="h2"
        style={{ marginBottom: '5px', marginTop: '5px', width: '80%' }}
      >
        <Skeleton />
      </Typography>
      <Typography>
        <Skeleton />
      </Typography>
      <Typography>
        <Skeleton />
      </Typography>
    </div>
  )
}

export default ReviewCardSkeleton
